import React from 'react';
import { RouterProvider } from 'react-router';
import ReactDOM from 'react-dom/client';

import 'styles/index.css';
import 'styles/scrollbar.css';
import router from 'routes';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<RouterProvider router={router} />);
